import React from 'react';
import {IndexLink, Link} from 'react-router';
import {connect} from 'react-redux';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

var querystring = require('querystring');
import CommentItem from './CommentItem';
import CommentBox from './CommentBox';

class ReplyComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            commentArr: [],
            comments: [],
            showReply: false
        };
    }

    componentDidMount = () => {
        this.setState({showReply: this.props.showReply}, () => {
            this.getReplies(this.props.comment.id_comment);
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({showReply: nextProps.showReply});
    }

    handleComment = (comment) => {
        var comments = this.state.comments;
        comments.unshift(comment);
        this.setState({comments: comments}, () => {
            this.generateComment(this.state.comments)
        });
    }

    generateComment = (comments) => {
        var newArry = [];
        if (comments.length > 0) {
            for (var c_item of comments) {
                newArry.unshift(
                    <CommentItem
                        key={"comment-" + c_item.id_comment}
                        user={this.props.user}
                        onChange={this.handleReplyChange.bind(this)}
                        comment={c_item}
                        isReply={1}
                    />
                )
            }
            this.setState({commentArr: newArry});
        }
    }

    handleReplyChange = (comment, type = "update") => {
        let commentList = this.state.comments;
        for (let i = 0; i < commentList.length; i++) {
            if (parseInt(commentList[i].id_comment) === parseInt(comment.id_comment)) {
                if(type == "delete")
                {
                    commentList.splice(i,1);
                }
                else {
                    commentList[i] = comment;
                }
                this.setState({comments: commentList}, () => {
                    this.generateComment(this.state.comments)
                });
                break;
            }
        }
    }

    getReplies = (id_comment) => {
        var url = '/code/api_experiences.php?api=getReplyCommentExperientials&id_comment_comment=' + id_comment;
        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({comments: response.data.data}, () => {
                        this.generateComment(this.state.comments)
                    });
                }
                return response;
            });
    }

    render() {
        return (
            <div className="comment_reply_section">
                {this.state.commentArr}
                <div className={this.state.showReply ? "" : "hide-el"}>
                    <CommentBox
                        getInput={this.props.getInput}
                        user={this.props.user}
                        comment={this.props.comment}
                        enable_ask={this.props.enable_ask}
                        onComment={this.handleComment.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

export default ReplyComment;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/experiential/ReplyComment.js
 **/